var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},_vm.$listeners),[_c('path',{attrs:{"d":"M88.3 52.8H11.8C10.2 52.8 9 51.5 9 50s1.2-2.8 2.8-2.8h76.5c1.5 0 2.8 1.2 2.8 2.8s-1.3 2.8-2.8 2.8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }